var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"modern-card",attrs:{"width":"100%","elevation":"0"}},[_c('apexchart',{attrs:{"width":"100%","height":"400","type":"bar","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }